import React from 'react';
import { useNavigation } from '../contexts/NavigationContext';
import { CaretLeft } from '@phosphor-icons/react/dist/ssr/CaretLeft';
import { BORDER_RADIUS, SHADOWS } from '../styles/UISystem';

/**
 * TomBackgroundShowcase - Preview different background styles for Tom's photo
 * Access at: /?screen=tom-backgrounds
 */
const TomBackgroundShowcase = () => {
  const { navigateTo } = useNavigation();

  const tomPhotoUrl = '/images/profiles/tom-myspace-no-bg.png';

  const backgrounds = [
    {
      name: 'Original',
      description: 'Classic Tom, no effects',
      style: {},
    },
    {
      name: 'Instagram Gradient',
      description: 'Pink/purple/orange like the IG logo',
      style: {
        background:
          'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
      },
    },
    {
      name: 'MySpace Blue',
      description: 'The OG social network vibes',
      style: {
        background: 'linear-gradient(135deg, #003366 0%, #006699 50%, #0099cc 100%)',
      },
    },
    {
      name: 'Vaporwave',
      description: 'A E S T H E T I C',
      style: {
        background: 'linear-gradient(180deg, #ff71ce 0%, #01cdfe 50%, #05ffa1 100%)',
      },
    },
    {
      name: 'Sunset',
      description: 'Golden hour Tom',
      style: {
        background: 'linear-gradient(180deg, #ff7e5f 0%, #feb47b 100%)',
      },
    },
    {
      name: 'Purple Haze',
      description: 'Chill purple vibes',
      style: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      },
    },
    {
      name: 'Retro Rainbow',
      description: 'Pride meets MySpace Top 8',
      style: {
        background:
          'linear-gradient(180deg, #ff0000 0%, #ff7f00 17%, #ffff00 33%, #00ff00 50%, #0000ff 67%, #4b0082 83%, #9400d3 100%)',
      },
    },
    {
      name: 'Teal Dream',
      description: 'Modern and fresh',
      style: {
        background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
      },
    },
    {
      name: 'Cotton Candy',
      description: 'Soft and sweet',
      style: {
        background: 'linear-gradient(135deg, #f5576c 0%, #f093fb 100%)',
      },
    },
    {
      name: 'Midnight',
      description: 'Dark and moody',
      style: {
        background: 'linear-gradient(135deg, #232526 0%, #414345 100%)',
      },
    },
    {
      name: 'Synthwave',
      description: '80s retro future',
      style: {
        background: 'linear-gradient(180deg, #2b1055 0%, #7597de 50%, #ff6b6b 100%)',
      },
    },
    {
      name: 'Ocean',
      description: 'Deep blue sea',
      style: {
        background: 'linear-gradient(180deg, #2193b0 0%, #6dd5ed 100%)',
      },
    },
  ];

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        padding: '20px',
        paddingBottom: '40px',
      }}
    >
      {/* Header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '24px',
          gap: '12px',
        }}
      >
        <div
          onClick={() => navigateTo('anon-connections-list')}
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '8px 10px',
            borderRadius: BORDER_RADIUS.PILL,
            backgroundColor: '#FFFFFF',
            boxShadow: SHADOWS.TIER1,
            cursor: 'pointer',
          }}
        >
          <CaretLeft size={24} color="#555555" weight="bold" />
        </div>
        <h1 style={{ fontSize: '24px', fontWeight: '700', margin: 0 }}>Tom Background Options</h1>
      </div>

      <p style={{ color: '#666', marginBottom: '24px', fontSize: '14px' }}>
        Pick a vibe for Tom&apos;s profile photo. These are CSS gradients that will appear behind
        his photo in both the list card and detail page.
      </p>

      {/* Grid of options */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
          gap: '16px',
        }}
      >
        {backgrounds.map((bg, index) => (
          <div
            key={index}
            style={{
              backgroundColor: '#fff',
              borderRadius: '16px',
              padding: '16px',
              textAlign: 'center',
              boxShadow: SHADOWS.TIER2,
            }}
          >
            {/* Circular photo with gradient background */}
            <div
              style={{
                width: '90px',
                height: '90px',
                borderRadius: '50%',
                margin: '0 auto 12px',
                backgroundColor: bg.style.background ? undefined : '#e8e8e8',
                backgroundImage: bg.style.background
                  ? `url(${tomPhotoUrl}), ${bg.style.background}`
                  : `url(${tomPhotoUrl})`,
                backgroundSize: '115%, cover',
                backgroundPosition: 'center 30%, center',
                backgroundRepeat: 'no-repeat, no-repeat',
              }}
            />

            {/* Name */}
            <div
              style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#000',
                marginBottom: '4px',
              }}
            >
              {bg.name}
            </div>

            {/* Description */}
            <div
              style={{
                fontSize: '12px',
                color: '#888',
              }}
            >
              {bg.description}
            </div>
          </div>
        ))}
      </div>

      <p style={{ color: '#999', marginTop: '24px', fontSize: '12px', textAlign: 'center' }}>
        Let me know which one you like and I&apos;ll implement it!
      </p>
    </div>
  );
};

export default TomBackgroundShowcase;
